export default {
  common: {
    send: "发送",
    submit: "提交",
    cancel: "取消",
    confirm: "确定",
    login: "登录",
    logout: "退出",
    logoutAccount: "退出登录",
    upload: "上传",
    newChat: "新建对话",
    conversation: "对话",
  },
  chat: {
    viewMoreAnswer: "查看更详尽的回答：",
    sourceFrom: "该信息来源于：",
    stopOutput: "停止输出",
    excelPrefix: "很高兴为您服务，请",
    excelSuffix: "您的Excel文件！",
    componentKnowledge: "元件知识集",
    initLoading: "初始化加载中，请耐心等待...",
    generateForm: "生成表单",
    openVip: "开通会员",
    welcome:
      "您好，我是电晓晓。您可以通过和我对话，快速获取电气成套行业知识、了解电气元件参数价格、查找替换元件、也可以试着让我帮您推荐成套设备BOM信息。期待您的体验和反馈。",
    tab: {
      selection: "选型与订购",
      usage: "使用条件",
      transport: "运输储存条件",
      tech: "技术参数",
      dimension: "尺寸与安装",
    },
    device: {
      purpose: "请选择你想要查询的用途",
      model: "请选择你想要查询的产品型号",
      size: "请选择你想要查询的柜宽*柜高*柜深",
      switchType: "请选择你想要查询的主开关类型",
      installType: "请选择你想要查询的主开关安装方式",
      current: "请选择你想要查询的主开关电流",
      breaking: "请选择你想要查询的主开关分段能力",
      brand: "请选择你想要查询的主开关品牌",
      summary:
        "您选择的柜体信息汇总如下：\n\n用途：{name}\n产品型号：{model}\n柜宽*柜高*柜深：{size}\n主开关类型：{typesof}\n主开关安装方式：{install}\n主开关电流：{electric}\n主开关分段能力：{segmenting}\n主开关品牌：{brand}",
    },
    title: {
      tryAsk: "您可以尝试这样问问：",
      canGenerateForm: "您可生成表单进行提问",
      satisfied: "您对该回答是否满意？可继续生成表单提问",
      freeUsedUp: "您今日的免费问答次数已用完，可开通会员畅享问答",
      moreRelated: "为你找到更多相关问答，点击试试吧：",
    },
    status: {
      thinking: "思考中...",
      stopped: "已停止输出",
    },
    action: {
      copy: "复制",
      regenerate: "重新生成",
      like: "喜欢",
      dislike: "不喜欢",
      downloadTable: "下载为表格",
    },
  },
  home: {
    dtx: "电天下",
    subscribe: "订阅服务",
    uploading: "上传中",
    uploadImage: "上传图片",
    holdToSpeak: "按住说话",
    listening: "正在聆听，请说话...",
    listeningShort: "正在聆听...",
    inputPlaceholder: "输入消息或图片 / 按住右侧麦克风说话…",
    releaseToSend: "松开发送到输入框",
  },
  login: {
    slogan: "优质电气数据分享社区,专业、有料、有趣",
    tabPersonal: "个人用户",
    tabEnterprise: "企业用户",
    phoneOrEmail: "手机号码/邮箱",
    phone: "手机号码",
    phoneShort: "手机号",
    password: "密码",
    verifyCode: "验证码",
    getVerifyCode: "获取验证码",
    imageCode: "图形验证码",
    switchToPhoneLogin: "手机验证码登录",
    switchToAccountLogin: "个人账号登录",
    enterpriseAccount: "企业账号",
    agreement: "注册登录即代表同意",
    privacy: " 《电天下网站个人隐私声明》 ",
  },
  loginView: {
    title: "登录",
    usernamePlaceholder: "用户名",
    passwordPlaceholder: "密码",
    forgetPassword: "忘记密码",
    forgetTitle: "忘记密码",
    account: "账号",
    accountPlaceholder: "请输入账号",
    password: "密码",
    // passwordPlaceholder: "请输入密码",
    confirmPassword: "确认密码",
    confirmPasswordPlaceholder: "请输入确认密码",
  },
  userLogin: {
    title: "电晓晓 AI智能客服",
    pleaseLogin: "请登录账号",
  },
  channelDialog: {
    tip: "提示：在正确的分类下咨询问题，本电晓晓才能回答更准确哦",
  },
  userAdvance: {
    question: "本次服务是否解决了您的问题",
    resolved: "已解决",
    unresolved: "未解决",
    suggestionPlaceholder: "您还有什么意见或建议",
  },
  vierPicture: {
    close: "关闭",
    export: "导出",
  },
  produceInfo: {
    currentProduct: "当前产品服务",
    intro: "产品介绍",
    resourcePurchase: "资源购买",
    community: "社区互动",
    cloudClass: "云课堂",
    scanFollow: "扫码关注更多利驰动态",
    leadreNews: "利驰动态",
  },
  mobileNav: {
    title: "电晓晓 - 电气AI助手",
  },
  recommended: {
    title: "热门活动推荐",
  },
  elementCard: {
    views: "浏览量:",
    favorites: "收藏量:",
  },
  errorPage: {
    back: "返回",
    gifSource: "gif来源",
    page: "页面",
    noPermission: "你没有权限去该页面",
    contactLeader: "如有不满请联系你领导",
    orYouCan: "或者你可以去:",
    backHome: "回首页",
    lookAround: "随便看看",
    clickToSee: "点我看图",
    randomTitle: "随便看",
    dtx: "电天下",
  },
  empty: {
    title: "后台首页",
    serverInfo: "服务器信息",
  },
};
